module.exports = __webpack_public_path__ + "img/entradas.a5b537ee.png";